/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Cases_By_Step_DescriptionInputs */

const en_dashboard_cases_by_step_description = /** @type {(inputs: Dashboard_Cases_By_Step_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case volume and combined claim value at each workflow step.`)
};

const pt_br2_dashboard_cases_by_step_description = /** @type {(inputs: Dashboard_Cases_By_Step_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume de casos e valor total combinado em cada etapa do fluxo.`)
};

/**
* | output |
* | --- |
* | "Case volume and combined claim value at each workflow step." |
*
* @param {Dashboard_Cases_By_Step_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_cases_by_step_description = /** @type {((inputs?: Dashboard_Cases_By_Step_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Cases_By_Step_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_cases_by_step_description(inputs)
	return pt_br2_dashboard_cases_by_step_description(inputs)
});